export default {
  en: {
    faq: 'FAQ',
    meta_faq_description:
      'Frequently asked questions about ChronoFox. Find answers to your questions about time tracking, project management, and more.',
    meta_keywords:
      'ChronoFox, FAQ, Frequently Asked Questions, Time Tracking, Project Management, ChronoFox Features',
    go_to_faq: 'Go to FAQ',
    faq_description:
      'Here you can find answers to frequently asked questions about ChronoFox. If you have any further questions, do not hesitate to contact us.',
    categories: 'Categories',
    getting_started: 'Getting Started',
    features: 'Features',
    technical: 'Technical Questions',
    billing: 'Billing and Subscriptions',
    support: 'Support and Troubleshooting',
    what_is_chronofox: 'What is ChronoFox and who is it for?',
    what_is_chronofox_answer:
      'ChronoFox is a time-tracking and project management tool designed for freelancers, small businesses, and teams to efficiently manage work hours, projects, and clients.',
    how_to_sign_up: 'How can I sign up for ChronoFox?',
    how_to_sign_up_answer:
      'You can sign up on the ChronoFox website. If you don’t have a subscription yet, you can register for the free version or directly select a plan.',
    is_chronofox_free: 'Is ChronoFox free?',
    is_chronofox_free_answer:
      'ChronoFox offers a free version for all users. Certain features are limited in this version, but you can upgrade to a paid subscription at any time.',
    how_does_chronofox_track_time: 'How does ChronoFox track time?',
    how_does_chronofox_track_time_answer:
      'ChronoFox provides a digital timer that you can start and stop to track work hours for specific tasks or projects. You can also add time entries manually.',
    can_i_manage_multiple_clients:
      'Can I manage multiple clients and projects with ChronoFox?',
    can_i_manage_multiple_clients_answer:
      'Yes, ChronoFox supports multiple clients and projects. You can assign tasks, track budgets, and monitor progress for each project.',
    can_i_customize_hourly_rates:
      'Can I customize hourly rates for different clients or projects?',
    can_i_customize_hourly_rates_answer:
      'Yes, you can set individual hourly rates for clients or projects to ensure accurate billing.',
    does_chronofox_support_team_collaboration:
      'Does ChronoFox support team collaboration?',
    does_chronofox_support_team_collaboration_answer:
      'Yes, ChronoFox allows multiple users to collaborate on projects and clients. Team functionalities will be further enhanced in the future.',
    can_i_generate_reports: 'Can I generate reports with ChronoFox?',
    can_i_generate_reports_answer:
      'ChronoFox offers detailed reporting features to track time, project budgets, and work hours. Reports can be shared with clients or used internally.',
    what_platforms_are_supported: 'What platforms are supported?',
    what_platforms_are_supported_answer:
      'ChronoFox is primarily available as a web app for both desktop and mobile devices. While there’s no standalone mobile app, the web app is optimized for mobile browsers.',
    is_my_data_secure: 'Is my data secure with ChronoFox?',
    is_my_data_secure_answer:
      'ChronoFox uses encryption and other security measures to ensure your data is protected and GDPR-compliant.',
    can_i_use_chronofox_offline: 'Can I use ChronoFox offline?',
    can_i_use_chronofox_offline_answer:
      'ChronoFox currently does not offer offline functionality as it operates as an internet-based Software-as-a-Service in the browser.',
    what_are_subscription_options: 'What subscription options are available?',
    what_are_subscription_options_answer:
      'ChronoFox offers various subscription plans. Visit the pricing page for detailed information.',
    how_to_cancel_subscription: 'How can I cancel my subscription?',
    how_to_cancel_subscription_answer:
      'You can cancel your subscription via your account settings. For further assistance, contact support.',
    are_there_discounts: 'Are there discounts for long-term subscriptions?',
    are_there_discounts_answer:
      'We’re happy to discuss your ChronoFox subscription and offer discounts for long-term subscriptions and/or subscriptions with many users. Contact us for personalized pricing.',
    how_to_contact_support: 'How can I contact ChronoFox support?',
    how_to_contact_support_answer: 'You can reach ChronoFox support via email.',
    what_to_do_if_password_forgotten:
      'What should I do if I forgot my password?',
    what_to_do_if_password_forgotten_answer:
      "Click 'Forgot Password' on the login page and follow the instructions to reset your password.",
    can_i_transfer_data: 'Can I transfer my data to or from ChronoFox?',
    can_i_transfer_data_answer:
      'Yes, you can import/export data such as time entries and client information. Import functionality is always available for paid subscriptions. The export options depend on your selected subscription plan. Visit the pricing page for more details.',
  },
  de: {
    faq: 'FAQ',
    meta_faq_description:
      'Häufig gestellte Fragen zu ChronoFox. Finde Antworten auf deine Fragen zur Zeiterfassung, Projektverwaltung und mehr.',
    meta_keywords:
      'ChronoFox, FAQ, Häufig gestellte Fragen, Zeiterfassung, Projektverwaltung, ChronoFox Funktionen',
    go_to_faq: 'Zum FAQ',
    faq_description:
      'Hier findest Du Antworten auf häufig gestellte Fragen zu ChronoFox. Wenn Du weitere Fragen haben solltest, zögere nicht, uns zu kontaktieren.',
    categories: 'Kategorien',
    getting_started: 'Erste Schritte',
    features: 'Funktionen',
    technical: 'Technische Fragen',
    billing: 'Abrechnung und Abonnements',
    support: 'Support und Fehlerbehebung',
    what_is_chronofox: 'Was ist ChronoFox und für wen ist es geeignet?',
    what_is_chronofox_answer:
      'ChronoFox ist ein Tool zur Zeiterfassung und Projektverwaltung, das für Freelancer, kleine Unternehmen und Teams entwickelt wurde, um Arbeitszeiten, Projekte und Kunden effizient zu verwalten.',
    how_to_sign_up: 'Wie kann ich mich bei ChronoFox registrieren?',
    how_to_sign_up_answer:
      'Sie können sich auf der ChronoFox-Website registrieren und anmelden. Wenn Sie bisher kein Abonnement haben, können Sie sich für eine kostenlose Version anmelden oder direkt einen Plan auswählen.',
    is_chronofox_free: 'Ist ChronoFox kostenlos?',
    is_chronofox_free_answer:
      'ChronoFox bietet eine kostenlose Variante für alle Benutzer. Natürlich sind hier einige Funktionen eingeschränkt, ein Upgrade auf ein kostenpflichtiges Abonnement ist jederzeit möglich.',
    how_does_chronofox_track_time: 'Wie erfasst ChronoFox meine Zeit?',
    how_does_chronofox_track_time_answer:
      'ChronoFox bietet einen digitalen Timer, den Sie starten und stoppen können, um Arbeitszeiten für bestimmte Aufgaben oder Projekte zu erfassen. Sie können auch manuell Zeiteinträge hinzufügen.',
    can_i_manage_multiple_clients:
      'Kann ich mehrere Kunden und Projekte mit ChronoFox verwalten?',
    can_i_manage_multiple_clients_answer:
      'Ja, ChronoFox unterstützt mehrere Kunden und Projekte. Sie können Aufgaben zuweisen, Budgets verfolgen und den Fortschritt für jedes Projekt überwachen.',
    can_i_customize_hourly_rates:
      'Kann ich Stundensätze für verschiedene Kunden oder Projekte anpassen?',
    can_i_customize_hourly_rates_answer:
      'Ja, Sie können für Kunden oder Projekte individuelle Stundensätze festlegen, um eine genaue Abrechnung sicherzustellen.',
    does_chronofox_support_team_collaboration:
      'Unterstützt ChronoFox die Zusammenarbeit im Team?',
    does_chronofox_support_team_collaboration_answer:
      'Ja, ChronoFox ermöglicht mehreren Benutzern die Zusammenarbeit an Projekten und Kunden. Sie können Benutzer zu Teams zuweisen. Die Teamfunktionalitäten werden in Zukunft noch weiter ausgebaut.',
    can_i_generate_reports: 'Kann ich Berichte mit ChronoFox erstellen?',
    can_i_generate_reports_answer:
      'ChronoFox bietet detaillierte Berichtsfunktionen, um Zeit, Projektbudgets und Arbeitsstunden zu verfolgen. Berichte können mit Kunden geteilt oder intern verwendet werden.',
    what_platforms_are_supported: 'Welche Plattformen werden unterstützt?',
    what_platforms_are_supported_answer:
      'ChronoFox ist primär als Web-App für sowohl Desktop und Mobil verfügbar. Zur Zeit gibt es keine mobile App, jedoch ist die Web-App für mobile Geräte optimiert und kann im Browser auf dem Handy genutzt werden.',
    is_my_data_secure: 'Sind meine Daten bei ChronoFox sicher?',
    is_my_data_secure_answer:
      'ChronoFox verwendet Verschlüsselung und andere Sicherheitsmaßnahmen, um sicherzustellen, dass Ihre Daten geschützt und GDPR-konform sind.',
    can_i_use_chronofox_offline: 'Kann ich ChronoFox offline verwenden?',
    can_i_use_chronofox_offline_answer:
      'ChronoFox bietet aktuell keine Offline-Funktionen, da der Dienst nur im Internet als Software-as-a-Service im Browser bereitsteht.',
    what_are_subscription_options: 'Welche Abonnementoptionen gibt es?',
    what_are_subscription_options_answer:
      'ChronoFox bietet mehrere Abonnements. Besuchen Sie die Preisseite für detaillierte Informationen zu den Plänen.',
    how_to_cancel_subscription: 'Wie kann ich mein Abonnement kündigen?',
    how_to_cancel_subscription_answer:
      'Sie können Ihr Abonnement über Ihre Kontoeinstellungen kündigen. Für weitere Unterstützung kontaktieren Sie den Support.',
    are_there_discounts: 'Gibt es Rabatte für langfristige Abonnements?',
    are_there_discounts_answer:
      'Wir bieten Ihnen gerne an, mit uns über Ihr ChronoFox Abonnement zu sprechen und bieten Ihnen Rabatte bei langfristigen Abonnements und/ oder Abonnements mit vielen Nutzenden. Kontaktieren Sie uns für individuelle Preise.',
    how_to_contact_support: 'Wie kann ich den ChronoFox-Support kontaktieren?',
    how_to_contact_support_answer:
      'Sie können den ChronoFox-Support per E-Mail erreichen.',
    what_to_do_if_password_forgotten:
      'Was soll ich tun, wenn ich mein Passwort vergessen habe?',
    what_to_do_if_password_forgotten_answer:
      "Klicken Sie auf der Login-Seite auf 'Passwort vergessen' und folgen Sie den Anweisungen, um Ihr Passwort zurückzusetzen.",
    can_i_transfer_data:
      'Kann ich meine Daten zu oder von ChronoFox übertragen?',
    can_i_transfer_data_answer:
      'Ja, Sie können Daten wie Zeiteinträge und Kundeninformationen importieren/exportieren. Ein Import steht für kostenpflichtige Abonnements immer zur Verfügung. Welche Export-Funktionen Ihnen zur Verfügung stehen hängt von Ihrem ausgewählten Abonnement ab. Auf der Preis Seite erfahren Sie mehr.',
  },
};
